__turbopack_context__.v({
  "bz-care-0": "ContentCard-module-scss-module__4-ap6q__bz-care-0",
  "bz-care-1": "ContentCard-module-scss-module__4-ap6q__bz-care-1",
  "bz-care-2": "ContentCard-module-scss-module__4-ap6q__bz-care-2",
  "bz-refund-0": "ContentCard-module-scss-module__4-ap6q__bz-refund-0",
  "bz-refund-1": "ContentCard-module-scss-module__4-ap6q__bz-refund-1",
  "bz-refund-2": "ContentCard-module-scss-module__4-ap6q__bz-refund-2",
  "title_area": "ContentCard-module-scss-module__4-ap6q__title_area",
});
